import React from 'react'
import styled from 'styled-components'

import { colors, rhythm } from '../utils/style-utils'

const Wrapper = styled.div`
  background: ${colors.black};
  color: ${colors.white};
  padding: ${rhythm(2)} 1em ${rhythm(2)};
`

const Content = styled.div`
  font-size: 12px;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;

  a {
    color: inherit;
  }
`

const Disclaimer = data => {
  const html = data.data.html
  return (
    <Wrapper>
      <Content dangerouslySetInnerHTML={{ __html: html }} />
    </Wrapper>
  )
}

export default Disclaimer



// WEBPACK FOOTER //
// ./src/components/Disclaimer.js